export default __webpack_public_path__ + "static/media/320x180.86b6afa0.jpg";